import axios from 'axios';

const state = {
  dataPoints: [],
  tempCountDataPoints: [],
  DFTDataPoints: [],
  bigCountDataPoints: [],
  yearRange: [],
  DFTYearSelected: '2017',
  bigCountYearSelected: '2017',
};

const getters = {
  allDataPoints: (stateTree) => stateTree.dataPoints,
  alltempCountDataPoints: (stateTree) => stateTree.tempCountDataPoints,
  allBigCountDataPoints: (stateTree) => stateTree.bigCountDataPoints,
  allDFTDataPoints: (stateTree) => stateTree.DFTDataPoints,
  getDFTYearSelected: (stateTree) => stateTree.DFTYearSelected,
  getBigCountYearSelected: (stateTree) => stateTree.bigCountYearSelected,
};
const headers = {
  withCredentials: false,
  // live
  'api-key-id': '418682ed-8cad-4ee2-915a-fb1f405a5eda',
  'api-key-secret': '$2a$10$cr9TwxjcEg6apUg9s6Xj0u0gCMQl0wjgtXMoo.Y9yhU.8w97e3xNW',
  // staging
  // "api-key-id": "fb6d2e42-f0c4-47cd-b843-7c36a1658885",
  // "api-key-secret": "d65ca26238281ed339e4adcb3e0d82d5ff15062dfd947d4e173e4de655509648"
};

const actions = {
  async fetchLiveCounter(context, date) {
    let dateTime = '';
    if (date.picker !== '') {
      dateTime = `ge(ISODateTime,${date.picker1})&le(ISODateTime,${date.picker})&`;
    }
    const params = 'aggregate(Latitude,Longitude,sum(Count))';
    const pedestrianData = await axios.get(
      `https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/02444e7a-5bd4-4ef3-9c66-e26671bb4c8a/latest/urql?eq(Class%20Name,pedestrian)&${dateTime}${params}`,
    );
    const bicycleData = await axios.get(
      `https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/02444e7a-5bd4-4ef3-9c66-e26671bb4c8a/latest/urql?eq(Class%20Name,bicycle)&${dateTime}${params}`,
    );
    const maxDateData = await axios.get(
      'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/02444e7a-5bd4-4ef3-9c66-e26671bb4c8a/latest/urql?max(ISODateTime)',
      {
        headers,
      },
    );

    const minDateData = await axios.get(
      'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/02444e7a-5bd4-4ef3-9c66-e26671bb4c8a/latest/urql?min(ISODateTime)',
      {
        headers,
      },
    );
    const pedestrian = pedestrianData.data;
    const bicycle = bicycleData.data;
    const minDate = minDateData.data;
    const maxDate = maxDateData.data;
    const result = {
      pedestrian, bicycle, minDate, maxDate,
    };
    context.commit('setDataPoints', JSON.parse(JSON.stringify(result)));
    return result;
  },
  async fetchTempCounterData(context, dataset) {
    const params = (column) => `aggregate(Latitude,Longitude,sum(${encodeURIComponent(column)}))`;
    const carData = await axios.get(
      `https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/${dataset}/latest/urql?${params(
        'Car',
      )}`,
      {
        headers,
      },
    );
    const taxiData = await axios.get(
      `https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/${dataset}/latest/urql?${params(
        'Taxi',
      )}`,
      {
        headers,
      },
    );
    const lgvData = await axios.get(
      `https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/${dataset}/latest/urql?${params(
        'LGV',
      )}`,
      {
        headers,
      },
    );
    const hgvData = await axios.get(
      `https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/${dataset}/latest/urql?${params(
        'HGV',
      )}`,
      {
        headers,
      },
    );
    const serviceBusData = await axios.get(
      `https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/${dataset}/latest/urql?${params(
        'Service Bus',
      )}`,
      {
        headers,
      },
    );
    const coachData = await axios.get(
      `https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/${dataset}/latest/urql?${params(
        'Coach',
      )}`,
      {
        headers,
      },
    );
    const mCycleData = await axios.get(
      `https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/${dataset}/latest/urql?${params(
        '\'M/Cycle\'',
      )}`,
      {
        headers,
      },
    );
    const cyclistData = await axios.get(
      `https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/${dataset}/latest/urql?${params(
        'Cyclist',
      )}`,
      {
        headers,
      },
    );
    const pedData = await axios.get(
      `https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/${dataset}/latest/urql?${params(
        'Pedestrian',
      )}`,
      {
        headers,
      },
    );

    const car = carData.data;
    const taxi = taxiData.data;
    const lgv = lgvData.data;
    const hgv = hgvData.data;
    const serviceBus = serviceBusData.data;
    const coach = coachData.data;
    const mCycle = mCycleData.data;
    const cyclist = cyclistData.data;
    const pedestrian = pedData.data;
    const result = {
      car, taxi, lgv, hgv, serviceBus, coach, mCycle, cyclist, pedestrian,
    };
    context.commit('setTempCountDataPoints', JSON.parse(JSON.stringify(result)));
    return result;
  },
  async fetchDFTDataset(context) {
    const year = state.DFTYearSelected;
    const response = await axios.get(
      `https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/207bc8d3-ef23-406b-91c8-adc12e5a9dae/latest/urql?ge(AADFYear,${year})&le(AADFYear,${parseInt(
        year,
        0,
      ) + 1})&aggregate(Northing,Easting,(sum(PedalCycles),sum(AllMotorVehicles)))`,
      {
        headers,
      },
    );
    const { data } = response;
    // const dataset = JSON.parse(JSON.stringify(response.data));
    context.commit('setDFTDataPoints', JSON.parse(JSON.stringify(data)));
    return data;
  },
  async fetchBigCountDataset(context) {
    const year = state.bigCountYearSelected;
    const response = await axios.get(
      `https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/4ecae34e-9382-404e-8728-a97df2f36b73/latest/urql?ge(Year,${year}-01)&le(Year,${year}-12)&aggregate(Latitude,Longitude,PostcodeArea,(sum(staff),sum(bikes)))`,
      {
        headers,
      },
    );
    const { data } = response;
    // const dataset = JSON.parse(JSON.stringify(response.data));
    context.commit('setBigCountDataPoints', JSON.parse(JSON.stringify(data)));
    return data;
  },
  async fetchTempCountDataset(context) {
    const year = state.bigCountYearSelected;
    const response = await axios.get(
      `https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/4ecae34e-9382-404e-8728-a97df2f36b73/latest/urql?ge(Year,${year}-01)&le(Year,${year}-12)&aggregate(Latitude,Longitude,PostcodeArea,(sum(staff),sum(bikes)))`,
      {
        headers,
      },
    );
    const { data } = response;
    // const dataset = JSON.parse(JSON.stringify(response.data));
    context.commit('setBigCountDataPoints', JSON.parse(JSON.stringify(data)));
    return data;
  },
};

const mutations = {
  setDataPoints(stateTree, data) {
    stateTree.dataPoints = data;
  },
  setTempCountDataPoints(stateTree, data) {
    stateTree.tempCountDataPoints = data;
  },
  setBigCountDataPoints(stateTree, data) {
    stateTree.bigCountDataPoints = data;
  },
  setDFTDataPoints(stateTree, data) {
    stateTree.DFTDataPoints = data;
  },
  setDFTYearSelected(stateTree, DFTYearSelected) {
    stateTree.DFTYearSelected = DFTYearSelected;
  },
  setBigCountSelected(stateTree, bigCountYearSelected) {
    stateTree.bigCountYearSelected = bigCountYearSelected;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
